export default __webpack_public_path__ + "static/pendantback-ff35f61725e548c460e2bc4ee1089a34.png";